"use client";

import ExpandableTextSection from "@/components/ExpandableTextSection";

export default function CityDynamicTextClient({ title, text }) {
  return (
    <div className="bg-background-global">
      <div className=" container relative overflow-hidden rounded-lg py-6 md:py-8">
        <ExpandableTextSection title={title} text={text} />
      </div>
    </div>
  );
}
